var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "session-card",
      class: { "session-card--current": _vm.session.isCurrent },
    },
    [
      _c("div", { staticClass: "session-card__row" }, [
        _c("div", { staticClass: "session-card__device" }, [
          _c(
            "div",
            { staticClass: "session-card__icons" },
            [
              _vm.isMobileApp
                ? [
                    _c(
                      "svg",
                      {
                        staticClass: "supsis-logo",
                        attrs: {
                          viewBox: "0 0 24 24",
                          width: "20",
                          height: "20",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "12",
                            cy: "12",
                            r: "11",
                            fill: "#1890ff",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            attrs: {
                              x: "12",
                              y: "17",
                              "text-anchor": "middle",
                              fill: "#fff",
                              "font-size": "14",
                              "font-weight": "bold",
                              "font-family": "Arial",
                            },
                          },
                          [_vm._v("S")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("md-icon", { staticClass: "mobile-app-icon" }, [
                      _vm._v("smartphone"),
                    ]),
                  ]
                : [
                    _c("DeviceIcon", {
                      attrs: {
                        type: "browser",
                        name: _vm.detectedClient || _vm.session.browser,
                        size: 20,
                      },
                    }),
                    _vm._v(" "),
                    _c("DeviceIcon", {
                      attrs: { type: "os", name: _vm.session.os, size: 16 },
                    }),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "session-card__device-info" }, [
            _c("span", { staticClass: "session-card__browser" }, [
              _vm._v(_vm._s(_vm.browserDisplay)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "session-card__os" }, [
              _vm._v(_vm._s(_vm.osDisplay)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.showUserInfo && _vm.session.userId
          ? _c(
              "div",
              { staticClass: "session-card__user" },
              [
                _c("a-avatar", {
                  attrs: { size: 20, icon: "user", src: _vm.userAvatar },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "session-card__user-name" }, [
                  _vm._v(_vm._s(_vm.userName)),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "session-card__location" },
          [
            _c("md-icon", { staticClass: "location-icon" }, [
              _vm._v("location_on"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.locationDisplay))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "session-card__ip" },
          [
            _c("md-icon", { staticClass: "ip-icon" }, [_vm._v("router")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.session.ipAddress || "-"))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "session-card__times" },
          [
            _c("a-tooltip", { attrs: { title: _vm.createdAtTooltip } }, [
              _c(
                "span",
                { staticClass: "session-card__time" },
                [
                  _c("md-icon", [_vm._v("event")]),
                  _vm._v(
                    " " + _vm._s(_vm.createdAtDisplay) + "\n                "
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("a-tooltip", { attrs: { title: _vm.lastAccessTooltip } }, [
              _c(
                "span",
                { staticClass: "session-card__time" },
                [
                  _c("md-icon", [_vm._v("access_time")]),
                  _vm._v(
                    " " + _vm._s(_vm.lastAccessDisplay) + "\n                "
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "session-card__status" },
          [
            _vm.session.isCurrent
              ? _c("a-tag", { attrs: { color: "green", size: "small" } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("sessions.currentSession")) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.session.platform === "mobile-app"
              ? _c("a-tag", { attrs: { color: "blue", size: "small" } }, [
                  _vm._v("\n                Mobile\n            "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "session-card__actions" },
          [
            !_vm.session.isCurrent
              ? _c(
                  "a-button",
                  {
                    attrs: { type: "danger", size: "small" },
                    on: { click: _vm.handleRevoke },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("sessions.revoke")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }